type StateDisplayName =
  'Alabama' | 'Alaska' | 'Arizona' | 'Arkansas' | 'California' |
  'Colorado' | 'Connecticut' | 'Delaware' | 'Florida' | 'Georgia' |
  'Hawaii' | 'Idaho' | 'Illinois' | 'Indiana' | 'Iowa' |
  'Kansas' | 'Kentucky' | 'Louisiana' | 'Maine' | 'Maryland' |
  'Massachusetts' | 'Michigan' | 'Minnesota' | 'Mississippi' | 'Missouri' |
  'Montana' | 'Nebraska' | 'Nevada' | 'New Hampshire' | 'New Jersey' |
  'New Mexico' | 'New York' | 'North Carolina' | 'North Dakota' | 'Ohio' |
  'Oklahoma' | 'Oregon' | 'Pennsylvania' | 'Rhode Island' | 'South Carolina' |
  'South Dakota' | 'Tennessee' | 'Texas' | 'Utah' | 'Vermont' |
  'Virginia' | 'Washington' | 'West Virginia' | 'Wisconsin' | 'Wyoming' |
  'American Samoa' | 'District of Columbia' | 'Federated States of Micronesia' | 'Guam' | 'Marshall Islands' |
  'Northern Mariana Islands' | 'Palau' | 'Puerto Rico' | 'United States Virgin Islands';

export type StateOrTerritory =
  'AL' | 'AK' | 'AZ' | 'AR' | 'CA' |
  'CO' | 'CT' | 'DE' | 'FL' | 'GA' |
  'HI' | 'ID' | 'IL' | 'IN' | 'IA' |
  'KS' | 'KY' | 'LA' | 'ME' | 'MD' |
  'MA' | 'MI' | 'MN' | 'MS' | 'MO' |
  'MT' | 'NE' | 'NV' | 'NH' | 'NJ' |
  'NM' | 'NY' | 'NC' | 'ND' | 'OH' |
  'OK' | 'OR' | 'PA' | 'RI' | 'SC' |
  'SD' | 'TN' | 'TX' | 'UT' | 'VT' |
  'VA' | 'WA' | 'WV' | 'WI' | 'WY' |
  'AS' | 'DC' | 'FM' | 'GU' | 'MH' |
  'MP' | 'PW' | 'PR' | 'VI';

export const states: StateOrTerritory[] = [
  'AL', 'AK', 'AZ', 'AR', 'CA',
  'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO',
  'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH',
  'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'WA', 'WV', 'WI', 'WY',
  'AS', 'DC', 'FM', 'GU', 'MH',
  'MP', 'PW', 'PR', 'VI'
];

export interface StatesDisplayAndAPI {
  value: StateDisplayName;
  key: StateOrTerritory;
}

export const stateDisplayNameAndApiName: StatesDisplayAndAPI[] = [
  {value: 'Alabama', key: 'AL'},
  {value: 'Alaska', key: 'AK'},
  {value: 'Arizona', key: 'AZ'},
  {value: 'Arkansas', key: 'AR'},
  {value: 'California', key: 'CA'},
  {value: 'Colorado', key: 'CO'},
  {value: 'Connecticut', key: 'CT'},
  {value: 'Delaware', key: 'DE'},
  {value: 'Florida', key: 'FL'},
  {value: 'Georgia', key: 'GA'},
  {value: 'Hawaii', key: 'HI'},
  {value: 'Idaho', key: 'ID'},
  {value: 'Illinois', key: 'IL'},
  {value: 'Indiana', key: 'IN'},
  {value: 'Iowa', key: 'IA'},
  {value: 'Kansas', key: 'KS'},
  {value: 'Kentucky', key: 'KY'},
  {value: 'Louisiana', key: 'LA'},
  {value: 'Maine', key: 'ME'},
  {value: 'Maryland', key: 'MD'},
  {value: 'Massachusetts', key: 'MA'},
  {value: 'Michigan', key: 'MI'},
  {value: 'Minnesota', key: 'MN'},
  {value: 'Mississippi', key: 'MS'},
  {value: 'Missouri', key: 'MO'},
  {value: 'Montana', key: 'MT'},
  {value: 'Nebraska', key: 'NE'},
  {value: 'Nevada', key: 'NE'},
  {value: 'New Hampshire', key: 'NH'},
  {value: 'New Jersey', key: 'NJ'},
  {value: 'New Mexico', key: 'NM'},
  {value: 'New York', key: 'NY'},
  {value: 'North Carolina', key: 'NC'},
  {value: 'North Dakota', key: 'ND'},
  {value: 'Ohio', key: 'OH'},
  {value: 'Oklahoma', key: 'OK'},
  {value: 'Oregon', key: 'OR'},
  {value: 'Pennsylvania', key: 'PA'},
  {value: 'Rhode Island', key: 'RI'},
  {value: 'South Carolina', key: 'SC'},
  {value: 'South Dakota', key: 'SD'},
  {value: 'Tennessee', key: 'TN'},
  {value: 'Texas', key: 'TX'},
  {value: 'Utah', key: 'UT'},
  {value: 'Vermont', key: 'VT'},
  {value: 'Virginia', key: 'VA'},
  {value: 'Washington', key: 'WA'},
  {value: 'West Virginia', key: 'WV'},
  {value: 'Wisconsin', key: 'WI'},
  {value: 'Wyoming', key: 'WY'},
  {value: 'American Samoa', key: 'AS'},
  {value: 'District of Columbia', key: 'DC'},
  {value: 'Federated States of Micronesia', key: 'FM'},
  {value: 'Guam', key: 'GU'},
  {value: 'Marshall Islands', key: 'MH'},
  {value: 'Northern Mariana Islands', key: 'MP'},
  {value: 'Palau', key: 'PW'},
  {value: 'Puerto Rico', key: 'PR'},
  {value: 'United States Virgin Islands', key: 'VI'},
];
